import { matchPath } from 'react-router-dom';

import { BundleTree } from '../../../../typings/configs';

export const hasRoute = (path: string, routes: BundleTree['routes']) => {
    const matchedRoute = routes.find((route) => matchPath(path, route));

    return Boolean(matchedRoute);
};
